import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useIsAuthenticated } from 'lib/oauth';
import { clearMemberFavourites, fetchMemberFavourites } from 'store/memberFavourites/memberFavouritesActions';

const MemberFavouritesFetcher = () => {
  const dispatch = useDispatch();

  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    isAuthenticated ? dispatch(fetchMemberFavourites()) : dispatch(clearMemberFavourites());
  }, [dispatch, isAuthenticated]);

  return null;
};

export default MemberFavouritesFetcher;
